import { ScreenManager, ScreenManagerEvents } from "../../managers/ScreenManager";
import { CardDeckData, CardPointsViewColumnData, CardPointsViewColumnItemData, CardPointsViewData, OptionsItemLiveData } from "../../types/types";
import { ScreenOrientationType } from "../../utils/GetOrientation";
import { CardRank } from "../card/Card";
import { LoaderFileKeys } from "../constant/AppConstants";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { AppLocalization, LanguageId } from "../localization/AppLocalization";
import { AppSettings } from "../managers/AppSettings";
import { OptionsItemKeys } from "../managers/LayoutDataManager";
import { VariationId } from "../screen/TableScreen";
import { TrumpSuit } from "../state/TableStateMachine";
import { TableToggleComponentView, ToggleState } from "./TableToggleComponentView";


/**
    Execution order:
    Init()
    Build()
    PostBuild();
    --
    SetData()?
    Reset()?
 */
export class CardPointsView extends TableToggleComponentView {
    /**
     * content titles 
     * i: 0=left, 1=right
     */
    public txtContentTitles: Phaser.GameObjects.Text[];

    /**
     * i: subContent index: 0=left, 1=right;
     * j: 0=left side, 1=right side; 
     * k: item(row) index
     */
    public txtContent: Phaser.GameObjects.Text[][][];

    /**
     * subcontent:
     * Subtitle, item listing
     */
    public contents: Phaser.GameObjects.Container[];
    // public conContentSub2: Phaser.GameObjects.Container;
    /**
     * Separator between content1 and content2
     */
    public verticalLine: Phaser.GameObjects.Image;

    // CardSuit-alike or NO_TRUMPS or ALL_TRUMPS
    private trumpSuit: TrumpSuit;
    private cardDeckIndex: number;

    private LIST_ITEM_SPACING: number = 60;


    public override Init(): void {
        super.Init();
        // override default ON/OFF bgProps
        this.bgPropsOff.radius = this.bgPropsOn.radius = { tl: this.bgRectRadius, tr: 0, br: 0, bl: this.bgRectRadius };
        this.bgPropsOn.height = 800;
    }

    public override Build(): void {
        // build:
        // - bg
        // - label
        // - arrow
        // - content (empty container)
        super.Build();

        this.contents = [];
        this.conContent = this.scene.make.container({});
        this.add(this.conContent);
        let subCont: Phaser.GameObjects.Container;
        subCont = this.scene.make.container({});
        this.contents.push(subCont);
        this.conContent.add(subCont);
        subCont = this.scene.make.container({});
        this.contents.push(subCont);
        this.conContent.add(subCont);

        const colorYellowString: string = AppSettings.colors.yellowString;
        const itemSubSpacingX: number = 30;
        let itemSubY: number;
        const textDash: string = "-";
        /*
            i [     0      ][     1      ]
            j [  0  ][  1  ][  0  ][  1  ]
            k [0...7][0...7][0...7][0...7]
        
            i: subContent index: 0=left, 1=right;
            j: 0=left side, 1=right side; 
            k: item(row) index
        */
        this.txtContent = [];
        this.txtContentTitles = [];
        let txt: Phaser.GameObjects.Text;
        for (let i = 0; i < 2; i++) {
            this.txtContent[i] = [];
            txt = this.scene.make.text({
                style: {
                    color: colorYellowString,
                    fontSize: "50px",
                    align: "center",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold50,
                }
            }).setOrigin(0.5);
            this.txtContentTitles.push(txt);
            this.contents[i].add(txt);
            for (let j = 0; j < 2; j++) {
                this.txtContent[i][j] = [];
                for (let k = 0; k < 8; k++) {
                    // console.log(i,j,k)
                    itemSubY = 100 + k * this.LIST_ITEM_SPACING;

                    if (j == 0) {
                        // console.log("left",i,j,k);
                        // dash once per subcolumn
                        // center item (dash)
                        txt = this.scene.make.text({
                            text: textDash,
                            style: {
                                color: "#fff",
                                fontSize: "50px",
                                align: "center",
                                fontFamily: AppSettings.fontFamilies.MontserratBold,
                                metrics: AppSettings.metrics.montserratBold50,
                            }
                        }).setOrigin(0.5).setPosition(0, itemSubY);
                        this.contents[i].add(txt);

                        // 'left' subcolumn item
                        txt = this.scene.make.text({
                            style: {
                                color: "#fff",
                                fontSize: "50px",
                                align: "center",
                                fontFamily: AppSettings.fontFamilies.MontserratBold,
                                metrics: AppSettings.metrics.montserratBold50,
                            }
                        }).setOrigin(1, 0.5).setPosition(-itemSubSpacingX, itemSubY);
                        this.txtContent[i][j].push(txt);
                        this.contents[i].add(txt);
                    }
                    else {
                        // console.log("right",i,j,k);
                        // 'right' subcolumn item
                        txt = this.scene.make.text({
                            style: {
                                color: "#fff",
                                fontSize: "50px",
                                align: "center",
                                fontFamily: AppSettings.fontFamilies.MontserratBold,
                                metrics: AppSettings.metrics.montserratBold50,
                            }
                        }).setOrigin(0, 0.5).setPosition(itemSubSpacingX, itemSubY);
                        this.txtContent[i][j].push(txt);
                        this.contents[i].add(txt);
                    }
                }
            }
        }

        // separator
        this.verticalLine = this.scene.make.image({ key: LoaderFileKeys.ui, frame: "rect-2x2-white-A50.png" });
        this.verticalLine.setOrigin(0.5, 0);
        // this.verticalLine.scale = 100;
        this.add(this.verticalLine);
    }

    public override Show(animated: boolean = true): void {
        // console.log("CardPointsView::Show");
        super.Show(animated);
    }

    public override Hide(animated: boolean = true): void {
        // console.log("CardPointsView::Hide");
        super.Hide(animated);
    }

    /**
     * Set trumpSuit and refresh view
     * Additionally, for NT or AT trumpSuit, check for toggle ntPoints130 or atPoints258
     * @param trumpSuit CardSuit-alike or NO_TRUMPS or ALL_TRUMPS
     * NOTE: undefined: always defined, but base expects no required params
     */
    public override SetData(
        trumpSuit: TrumpSuit = undefined,
        cardDeckIndex: number = undefined
    ): void {
        const cardDeckData: CardDeckData = AppLocalization.GetCardDeckData(cardDeckIndex);
        let sharedColumnsData: CardPointsViewColumnData[];
        let cardDeckColumnsData: CardPointsViewColumnData[];
        this.trumpSuit = trumpSuit;
        if (trumpSuit == TrumpSuit.ALLTRUMPS || trumpSuit == TrumpSuit.NOTRUMPS) {
            const variationId: VariationId = AppLocalization.GetCurVariationId();
            // 1 column
            this.bgPropsOn.width = 500;
            // set textfield values
            if (trumpSuit == TrumpSuit.ALLTRUMPS) {
                const atPoints258: OptionsItemLiveData = VariationId == undefined ? null : OptionsDataManager.GetItemDataByItemId(OptionsItemKeys.atPoints258, variationId);
                if (atPoints258 && atPoints258.value) {
                    // "AT-258"
                    sharedColumnsData = AppLocalization.GetSharedData().table.cardPointsView.at258.columns;
                    cardDeckColumnsData = cardDeckData.cardPointsView.at258.columns;
                }
                else {
                    // "ALL TRUMPS"
                    sharedColumnsData = AppLocalization.GetSharedData().table.cardPointsView.alltrumps.columns;
                    cardDeckColumnsData = cardDeckData.cardPointsView.alltrumps.columns;
                }
            }
            else
                if (trumpSuit == TrumpSuit.NOTRUMPS) {
                    const ntPoints130: OptionsItemLiveData = variationId == undefined ? null : OptionsDataManager.GetItemDataByItemId(OptionsItemKeys.ntPoints130, variationId);
                    if (ntPoints130 && ntPoints130.value) {
                        // "NT-130"
                        sharedColumnsData = AppLocalization.GetSharedData().table.cardPointsView.nt130.columns;
                        cardDeckColumnsData = cardDeckData.cardPointsView.nt130.columns;
                    }
                    else {
                        // "NO TRUMPS"
                        sharedColumnsData = AppLocalization.GetSharedData().table.cardPointsView.notrumps.columns;
                        cardDeckColumnsData = cardDeckData.cardPointsView.notrumps.columns;
                    }
                }
        }
        else {
            // 2 columns with separator
            this.bgPropsOn.width = 600;
            // "TRUMP" and "OTHER" columns
            sharedColumnsData = AppLocalization.GetSharedData().table.cardPointsView.trump.columns;
            cardDeckColumnsData = cardDeckData.cardPointsView.trump.columns;
        }
        this.UpdateDelimiterVisibility();

        // 
        // console.log(sharedColumnsData)
        cardDeckColumnsData.forEach((col: CardPointsViewColumnData, i: number) => {
            this.txtContentTitles[i].text = sharedColumnsData[i].title;
            col.columns.forEach((item: CardPointsViewColumnItemData, j: number) => {
                // i = main column (eg: TRUMP|OTHER)
                // j = left/right (eg: TANK|VALUE eg: A|11)
                // this.txtContent[i][0][j].text = "L";
                // this.txtContent[i][1][j].text = "R";
                this.txtContent[i][0][j].text = item.rank;
                this.txtContent[i][1][j].text = item.value;
            });
        });

        // refresh view (position, size, visibility)
        const curOrientation: ScreenOrientationType = ScreenManager.GetOrientation();
        this.UpdateViewFromOrientationChange(curOrientation);
    }

    /**
     * Updates from DATA (custom) change, 
     * BUT considers orientation (redraws and repositions based on orientation)
     * @param newOrientation 
     */
    protected override UpdateViewFromOrientationChange(newOrientation: ScreenOrientationType): void {
        // console.log(ScreenOrientationType[newOrientation]);

        // let containerPivot:ContainerPivot;
        const props = this.toggleState == ToggleState.ON ? this.bgPropsOn : this.bgPropsOff;
        let conContentX: number = -props.width * 0.5;
        switch (newOrientation) {
            // Note: LANDSCAPE orient. view has Container content ALIGNED BOTTOM-LEFT
            case ScreenOrientationType.LANDSCAPE:
                // redraw bg
                this.grBg.clear();
                // this.grBg.lineStyle(props.style.lineStyle.width, props.style.lineStyle.color, props.style.lineStyle.alpha);
                this.grBg.fillStyle(props.style.fillStyle.color, props.style.fillStyle.alpha);
                // this.grBg.strokeRoundedRect(-props.width, -props.height, props.width, props.height, props.radius);
                this.grBg.fillRoundedRect(-props.width, -props.height, props.width, props.height, props.radius);

                if (this.toggleState == ToggleState.OFF) {
                    this.txtLabel.setPosition(conContentX, -props.height * 0.5);
                }
                else
                    if (this.toggleState == ToggleState.ON) {
                        this.txtLabel.setPosition(conContentX, -props.height + 30 + this.txtLabel.displayHeight * 0.5);
                        this.conContent.setPosition(conContentX, -props.height + 200);
                    }

                // bg hitArea to make this component toggleable
                this.bgHitArea.setPosition(-props.width, -props.height);
                this.bgHitArea.setSize(props.width, props.height);
                this.grBg.setInteractive({
                    hitArea: this.bgHitArea,
                    hitAreaCallback: Phaser.Geom.Rectangle.Contains,
                    // draggable: false,
                    useHandCursor: true,
                });
                break;

            // Note: PORTRAIT orient. view has Container content ALIGNED TOP-LEFT
            case ScreenOrientationType.PORTRAIT:
                // redraw bg
                this.grBg.clear();
                // this.grBg.lineStyle(props.style.lineStyle.width, props.style.lineStyle.color, props.style.lineStyle.alpha);
                this.grBg.fillStyle(props.style.fillStyle.color, props.style.fillStyle.alpha);
                // this.grBg.strokeRoundedRect(-props.width, 0, props.width, props.height, props.radius);
                this.grBg.fillRoundedRect(-props.width, 0, props.width, props.height, props.radius);

                if (this.toggleState == ToggleState.OFF) {
                    this.txtLabel.setPosition(conContentX, props.height * 0.5);
                }
                else
                    if (this.toggleState == ToggleState.ON) {
                        this.txtLabel.setPosition(-props.width * 0.5, 30 + this.txtLabel.displayHeight * 0.5);
                        this.conContent.setPosition(conContentX, 200);
                    }


                // bg hitArea to make this component toggleable
                this.bgHitArea.setPosition(-props.width, 0);
                this.bgHitArea.setSize(props.width, props.height);
                this.grBg.setInteractive({
                    hitArea: this.bgHitArea,
                    hitAreaCallback: Phaser.Geom.Rectangle.Contains,
                    // draggable: false,
                    useHandCursor: true,
                });
        }
        // arrow
        this.imgArrow.setPosition(-props.width + 25, this.txtLabel.y);

        // any ORIENTATION, but ON toggleState (conContent visible)
        if (this.toggleState == ToggleState.ON) {
            // 
            if (this.trumpSuit == TrumpSuit.ALLTRUMPS || this.trumpSuit == TrumpSuit.NOTRUMPS) {
                // this.conContentSub1.x = 0;
                // this.conContentSub2.visible = false;
                this.contents[0].x = 0;
                this.contents[1].visible = false;
            }
            else {
                // this.conContentSub1.x = -150;
                // this.conContentSub2.x = 150;
                // this.conContentSub2.visible = true;
                this.contents[0].x = -150;
                this.contents[1].x = 150;
                this.contents[1].visible = true;
            }

            // verticalLine
            this.verticalLine.setPosition(conContentX, this.conContent.y + 70);
            this.verticalLine.displayHeight = 480;

            this.imgArrow.visible = true;
            this.conContent.visible = true;
        }
        else {
            this.imgArrow.visible = false;
            this.conContent.visible = false;
        }

        this.UpdateDelimiterVisibility();
    }

    private UpdateDelimiterVisibility(): void {
        if (this.toggleState == ToggleState.ON) {
            if (this.trumpSuit == TrumpSuit.ALLTRUMPS || this.trumpSuit == TrumpSuit.NOTRUMPS) {
                this.verticalLine.visible = false;
            }
            else {
                this.verticalLine.visible = true;
            }
        }
        else {
            this.verticalLine.visible = false;
        }
    }

    public UpdateViewFromLocalizationChange(languageId: LanguageId): void {
        // console.log(LanguageId[languageId]);

        this.txtLabel.text = AppLocalization.GetSharedData(languageId).table.cardPointsView.title;

        // console.log("TODO update column titles")
        // NOTE: SetData is called via TableScreen::UpdateViewFromData, which updates the columns and their titles.
    }
}